<template>
    <div>
        <div class="modals-recherche">
            <b-modal id="selectionFormation"
                     class="selectionFormation"
                     :modal-class="ModalFormationShown ? 'in':''"
                     size="lg"
                     title="Sélection des formations"
                     :hide-header-close="true"
                     :title-tag="'h4'"
                     cancel-title="Annuler"
                     @shown="ModalFormationShown=true"
                     @hidden="ModalFormationShown=false"
            >
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group well">
                            <label for="">Sélection actuelle: {{formationsSelected.length}}
                                {{formationsSelected.length>1 ? 'formations sélectionnées' :'formation sélectionnée'}}</label>
                            <div class="checkbox "
                                 v-if="formationsSelected.length>0"
                                 v-for="formation in formationsSelected">
                                <label :for="'mf_se'+formation.value">
                                    <input :id="'mf_se'+formation.value"
                                           type="checkbox"
                                           :value="formation"
                                           v-model="formationsSelected">
                                    {{formation.text}} |
                                    <router-link
                                            class="padding2"
                                            :to="{ name: 'Formation', params: { formation_id: formation.value }}">
                                        <i class="glyphicon glyphicon glyphicon-copy"></i>
                                    </router-link>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">Liste des formations</label>

                            <div class="row">
                                <div class="col-md-12">
                                    <b-form-input v-model="filterFormation"
                                                  type="text"
                                                  placeholder="Filtrer les formations">
                                    </b-form-input>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-12">
                                    <div class="checkbox"
                                         v-if="listeFormation().length>0"
                                         v-for="formation in listeFormation()">
                                        <label :for="'mf_'+formation.value">
                                            <input :id="'mf_'+formation.value"
                                                   type="checkbox"
                                                   :value="formation"
                                                   v-model="formationsSelected">
                                            {{formation.text}} |
                                            <router-link
                                                    class="padding2"
                                                    :to="{ name: 'Formation', params: { formation_id: formation.value }}">
                                                <i class="glyphicon glyphicon glyphicon-copy"></i>
                                            </router-link>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </b-modal>

            <b-modal id="selectionClub"
                     class="selectionClub"
                     :modal-class="ModalClubShown ? 'in':''"
                     size="lg"
                     title="Sélection des clubs"
                     :hide-header-close="true"
                     :title-tag="'h4'"
                     cancel-title="Annuler"
                     @shown="ModalClubShown=true"
                     @hidden="ModalClubShown=false"
            >
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group well">
                            <label for="">Sélection actuelle: {{clubsSelected.length}} {{clubsSelected.length>1 ? 'clubs sélectionnés' :'club sélectionné'}}</label>
                            <div class="input-group" v-if="clubsSelected.length>0" style="margin-bottom: 10px;">
                                <input type="text" class="form-control"
                                       readonly
                                       @focus="$event.target.select()"
                                       :value="clubsMailsTextarea()">
                                <span class="input-group-btn">
                                    <a type="button"
                                       @click="copyToClipboard(clubsMailsTextarea())"
                                       class="btn btn-primary btn-flat">Copier les e-mails des clubs</a>
                                </span>
                            </div>
                            <div class="checkbox "
                                 v-if="clubsSelected.length>0"
                                 v-for="club in clubsSelected">
                                <label :for="'mc_se'+club.value">
                                    <input :id="'mc_se'+club.value"
                                           type="checkbox"
                                           :value="club"
                                           v-model="clubsSelected">
                                    <span v-html="club.text"></span>
                                    |
                                    <router-link
                                            class="padding2"
                                            :to="{ name: 'Club', params: { club_id: club.value }}">
                                        <i class="glyphicon glyphicon glyphicon-copy"></i>
                                    </router-link>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">Liste des clubs</label>

                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-input v-model="filterClub"
                                                  type="text"
                                                  placeholder="Filtrer les clubs par nom">
                                    </b-form-input>
                                </div>
                                <div class="col-md-6">
                                    <select class="form-control" v-model="filterProvince">
                                        <option :value="null">Toutes les provinces</option>
                                        <option v-for="prov in getProvinces" :key="prov.id" :value="prov.id">
                                            {{prov.province}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="pull-right">
                                        <a @click.prevent="selectAllClubsDisplayed()" href="#">Sélectionner tous les clubs affichés</a> |
                                        <a @click.prevent="toogleSelectClubsLicencies()" href="#">Sélectionner tous les clubs licenciés</a> |
                                        <a @click.prevent="clubsSelected=[]" href="#">Réinitialiser la sélection</a>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="checkbox"
                                         v-if="listeClub().length>0"
                                         v-for="club in listeClub()">
                                        <label :for="'mc_'+club.value">
                                            <input :id="'mc_'+club.value"
                                                   type="checkbox"
                                                   :value="club"
                                                   v-model="clubsSelected">
                                            <span v-html="club.text"></span> |
                                            <router-link
                                                    class="padding2"
                                                    :to="{ name: 'Club', params: { club_id: club.value }}">
                                                <i class="glyphicon glyphicon glyphicon-copy"></i>
                                            </router-link>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </b-modal>

            <b-modal id="selectionCompetition"
                     class="selectionCompetition"
                     :modal-class="ModalCompetitionShown ? 'in':''"
                     size="lg"
                     title="Sélection des compétitions"
                     :hide-header-close="true"
                     :title-tag="'h4'"
                     cancel-title="Annuler"
                     @shown="ModalCompetitionShown=true"
                     @hidden="ModalCompetitionShown=false"
            >
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group well">
                            <label for="">Sélection actuelle: {{competitionsSelected.length}}
                                {{competitionsSelected.length>1 ? 'compétitions sélectionnées' :'compétition sélectionnée'}}</label>
                            <div class="checkbox "
                                 v-if="competitionsSelected.length>0"
                                 v-for="competition in competitionsSelected">
                                <label :for="'mcom_se'+competition.value">
                                    <input :id="'mcom_se'+competition.value"
                                           type="checkbox"
                                           :value="competition"
                                           v-model="competitionsSelected">
                                    {{competition.text}} |
                                    <router-link
                                            class="padding2"
                                            :to="{ name: 'Competition', params: { competition_id: competition.value }}">
                                        <i class="glyphicon glyphicon glyphicon-copy"></i>
                                    </router-link>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">Liste des compétitions</label>

                            <div class="row">
                                <div class="col-md-12">
                                    <b-form-input v-model="filterCompetition"
                                                  type="text"
                                                  class="col-md-4"
                                                  placeholder="Filtrer les compétitions">
                                    </b-form-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="checkbox"
                                         v-if="listeCompetition().length>0"
                                         v-for="competition in listeCompetition()">
                                        <label :for="'mcom_'+competition.value">
                                            <input :id="'mcom_'+competition.value"
                                                   type="checkbox"
                                                   :value="competition"
                                                   v-model="competitionsSelected">
                                            {{competition.text}} |
                                            <router-link
                                                    class="padding2"
                                                    :to="{ name: 'Competition', params: { competition_id: competition.value }}">
                                                <i class="glyphicon glyphicon glyphicon-copy"></i>
                                            </router-link>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </b-modal>

            <b-modal id="selectionDiplomes"
                     class="selectionDiplomes"
                     :modal-class="ModalDiplomeShown ? 'in':''"
                     size="lg"
                     title="Sélection des diplômes"
                     :hide-header-close="true"
                     :title-tag="'h4'"
                     cancel-title="Annuler"
                     @shown="ModalDiplomeShown=true"
                     @hidden="ModalDiplomeShown=false"
            >
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group well">
                            <label for="">Sélection actuelle: {{diplomesSelected.length}} {{diplomesSelected.length>1 ?
                                'diplômes/grades sélectionnés' :'diplôme/grade sélectionné'}}</label>
                            <div class="checkbox "
                                 v-if="diplomesSelected.length>0"
                                 v-for="diplome in diplomesSelected">
                                <label :for="'md_se'+diplome.value">
                                    <input :id="'md_se'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Ceintures noires</label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['noire','poom'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Basses ceintures</label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['keup'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">ADEPS </label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['adeps_general','adeps','adeps_2013', 'adeps_ancien','adeps_avant'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Arbitre combat </label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['arbitre_combat'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                            <label for="">Arbitre techinque </label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome([,'arbitre_technique'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">ABFT / AISF / STATUTS</label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['abft','aisf','statut_sportif'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">AISF </label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['aisf'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Statuts sportifs </label>
                            <div class="checkbox"
                                 v-for="diplome in listeDiplome(['statut_sportif'])">
                                <label :for="'md_'+diplome.value">
                                    <input :id="'md_'+diplome.value"
                                           type="checkbox"
                                           :value="diplome"
                                           v-model="diplomesSelected">
                                    {{diplome.text}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </b-modal>

            <b-modal id="selectionPoste"
                     class="selectionPoste"
                     :modal-class="ModalPosteShown ? 'in':''"
                     size="lg"
                     title="Sélection des compétitions"
                     :hide-header-close="true"
                     :title-tag="'h4'"
                     cancel-title="Annuler"
                     @shown="ModalPosteShown=true"
                     @hidden="ModalPosteShown=false"
            >
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group well">
                            <label for="">Sélection actuelle: {{postesSelected.length}}
                                {{postesSelected.length>1 ? 'postes sélectionnés' :'poste sélectionné'}}</label>
                            <div class="checkbox "
                                 v-if="postesSelected.length>0"
                                 v-for="poste in postesSelected">
                                <label :for="'mposte_se'+poste.value">
                                    <input :id="'mposte_se'+poste.value"
                                           type="checkbox"
                                           :value="poste"
                                           v-model="postesSelected">
                                    {{poste.text}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">Liste des postes</label>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="checkbox"
                                         v-if="listePoste().length>0"
                                         v-for="poste in listePoste()">
                                        <label :for="'mposte_'+poste.value">
                                            <input :id="'mposte_'+poste.value"
                                                   type="checkbox"
                                                   :value="poste"
                                                   v-model="postesSelected">
                                            {{poste.text}}
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </b-modal>
        </div>

        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    Recherche avancée
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Outils</a></li>
                    <li class="active">Recherche avancée</li>
                </ol>
            </section>

            <section class="content">
                <div class="row">

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="box box-primary">
                            <div class="overlay"
                                 v-if="!allLoading() || searching">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                            <div class="box-header with-border">
                                <h3 class="box-title">Critères</h3>
                            </div>
                            <div class="box-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="ressourceDemandee">Ressource demandée</label>
                                            <select name="ressourceDemandee" id="ressourceDemandee"
                                                    class="form-control"
                                                    v-model="ressourceDemandee">
                                                <option :value="null"></option>
                                                <option value="membre">Membres</option>
                                                <!--<option value="club">Clubs</option>-->
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="ressourceDemandee=='membre'">
                                        <div class="form-group">
                                            <label for="optionsMembre[isLicencie]">En ordre de licence ?
                                                <i class="fa fa-info-circle text-info rav-info"
                                                   v-b-tooltip.hover.top
                                                   title="Avec « Sans importance » combiné à une recherche sur un ou plusieurs clubs, le résultat inclut les membres ayant eu au moins une fois une licence dans l'un des clubs sélectionnés."></i>
                                            </label>
                                            <select name="optionsMembre[isLicencie]"
                                                    id="optionsMembre[isLicencie]"
                                                    class="form-control"
                                                    v-model="optionsMembre['isLicencie']">
                                                <option value="2">Sans importance</option>
                                                <option value="1">Oui</option>
                                                <option value="0">Non</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="ressourceDemandee=='membre'">
                                        <label>&nbsp;</label>
                                        <b-form-checkbox id="chkIncludeAdmin"
                                                         v-model="include_administrative_members">
                                            Inclure les membres administratifs
                                        </b-form-checkbox>
                                    </div>
                                </div>

                                <div class="rav-criteres" v-if="ressourceDemandee=='membre'">
                                    <!-- Formations -->
                                    <div class="rav-crit">
                                        <div class="rav-crit-head">
                                            <i class="fa fa-graduation-cap rav-crit-icon"></i>
                                            <span class="rav-crit-label">Formations</span>
                                            <span class="label rav-crit-count"
                                                  :class="formationsSelected.length ? 'label-primary' : 'label-default'">{{formationsSelected.length}}</span>
                                            <b-btn size="sm" variant="default" class="rav-add-btn" v-b-modal.selectionFormation>
                                                <i class="fa fa-plus"></i> Ajouter
                                            </b-btn>
                                        </div>
                                        <div class="rav-chips" v-if="formationsSelected.length>0">
                                            <span class="rav-chip" v-for="f in formationsSelected" :key="f.value">
                                                {{f.text}}
                                                <a href="#" class="rav-chip-x" title="Retirer"
                                                   @click.prevent="removeChip(formationsSelected, f)">&times;</a>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Compétitions -->
                                    <div class="rav-crit">
                                        <div class="rav-crit-head">
                                            <i class="fa fa-trophy rav-crit-icon"></i>
                                            <span class="rav-crit-label">Compétitions</span>
                                            <span class="label rav-crit-count"
                                                  :class="competitionsSelected.length ? 'label-primary' : 'label-default'">{{competitionsSelected.length}}</span>
                                            <b-btn size="sm" variant="default" class="rav-add-btn" v-b-modal.selectionCompetition>
                                                <i class="fa fa-plus"></i> Ajouter
                                            </b-btn>
                                        </div>
                                        <div class="rav-chips" v-if="competitionsSelected.length>0">
                                            <span class="rav-chip" v-for="c in competitionsSelected" :key="c.value">
                                                {{c.text}}
                                                <a href="#" class="rav-chip-x" title="Retirer"
                                                   @click.prevent="removeChip(competitionsSelected, c)">&times;</a>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Diplômes / grades -->
                                    <div class="rav-crit">
                                        <div class="rav-crit-head">
                                            <i class="fa fa-certificate rav-crit-icon"></i>
                                            <span class="rav-crit-label">Diplômes / grades</span>
                                            <span class="label rav-crit-count"
                                                  :class="diplomesSelected.length ? 'label-primary' : 'label-default'">{{diplomesSelected.length}}</span>
                                            <b-btn size="sm" variant="default" class="rav-add-btn" v-b-modal.selectionDiplomes>
                                                <i class="fa fa-plus"></i> Ajouter
                                            </b-btn>
                                        </div>
                                        <div class="rav-chips" v-if="diplomesSelected.length>0">
                                            <span class="rav-chip" v-for="d in diplomesSelected" :key="d.value">
                                                {{d.text}}
                                                <a href="#" class="rav-chip-x" title="Retirer"
                                                   @click.prevent="removeChip(diplomesSelected, d)">&times;</a>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Clubs -->
                                    <div class="rav-crit">
                                        <div class="rav-crit-head">
                                            <i class="fa fa-home rav-crit-icon"></i>
                                            <span class="rav-crit-label">Clubs</span>
                                            <span class="label rav-crit-count"
                                                  :class="clubsSelected.length ? 'label-primary' : 'label-default'">{{clubsSelected.length}}</span>
                                            <b-btn size="sm" variant="default" class="rav-add-btn" v-b-modal.selectionClub>
                                                <i class="fa fa-plus"></i> Ajouter
                                            </b-btn>
                                        </div>
                                        <div class="rav-chips" v-if="clubsSelected.length>0">
                                            <span class="rav-chip" v-for="club in clubsSelected" :key="club.value">
                                                <span v-html="club.text"></span>
                                                <a href="#" class="rav-chip-x" title="Retirer"
                                                   @click.prevent="removeChip(clubsSelected, club)">&times;</a>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Mandats / postes -->
                                    <div class="rav-crit">
                                        <div class="rav-crit-head">
                                            <i class="fa fa-user rav-crit-icon"></i>
                                            <span class="rav-crit-label">Mandats
                                                <small class="text-muted"
                                                       v-if="!poste_only_for_club_licencie && !poste_only_for_clubs_selected">(sans distinction de club)</small></span>
                                            <span class="label rav-crit-count"
                                                  :class="postesSelected.length ? 'label-primary' : 'label-default'">{{postesSelected.length}}</span>
                                            <b-btn size="sm" variant="default" class="rav-add-btn" v-b-modal.selectionPoste>
                                                <i class="fa fa-plus"></i> Ajouter
                                            </b-btn>
                                        </div>
                                        <div class="rav-chips" v-if="postesSelected.length>0">
                                            <span class="rav-chip" v-for="poste in postesSelected" :key="poste.value">
                                                {{poste.text}}
                                                <a href="#" class="rav-chip-x" title="Retirer"
                                                   @click.prevent="removeChip(postesSelected, poste)">&times;</a>
                                            </span>
                                        </div>
                                        <div class="rav-crit-options" v-if="postesSelected.length>0">
                                            <b-form-checkbox id="chkPosteLicencie"
                                                             v-model="poste_only_for_club_licencie">
                                                Dans un club licencié uniquement
                                            </b-form-checkbox>
                                            <b-form-checkbox id="chkPosteClubsSelected"
                                                             v-show="clubsSelected.length>0"
                                                             v-model="poste_only_for_clubs_selected">
                                                Dans les clubs sélectionnés uniquement
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box-footer">
                                <span class="rav-active-filters">
                                    <i class="fa fa-filter"></i>
                                    {{activeFiltersCount}} filtre{{activeFiltersCount>1 ? 's':''}} actif{{activeFiltersCount>1 ? 's':''}}
                                </span>
                                <button
                                        @click.prevent="searchAdvanced()"
                                        :disabled="searching"
                                        type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                                    <i class="fa fa-search"></i> Rechercher
                                </button>
                                <button
                                        @click.prevent="resetCriteres()"
                                        :disabled="activeFiltersCount===0"
                                        type="button" class="btn btn-default pull-right" style="margin-right: 5px;">
                                    Réinitialiser
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="box box-primary rav-results-box">
                            <div class="box-header with-border">
                                <div class="pull-left">
                                    <h3 class="box-title">{{pagination_meta.total}} résultat{{pagination_meta.total>1 ? 's':''}}</h3>

                                </div>
                                <div class="pull-right">
                                    <div style="display:inline-block" class="margin-r-5">
                                        <span style="display:inline-block">Par Page:</span>
                                        <select class="form-control" v-model="pagination_meta.per_page"
                                                style="display:inline-block;width: 100px;">
                                            <option :value="20">20</option>
                                            <option :value="50">50</option>
                                            <option :value="75">75</option>
                                            <option :value="100">100</option>
                                            <option :value="999999">Tout</option>
                                        </select>
                                    </div>

                                    <div class="btn-group margin-r-5 ">
                                        <button :disabled="resultatsRecherche.length==0" :class="{'disabled':resultatsRecherche.length==0}" @click.prevent="selectAll()" type="button" class="btn btn-default">Sélectionner tout</button>
                                        <button :disabled="resultatsRecherche.length==0" :class="{'disabled':resultatsRecherche.length==0}" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                                            <span class="caret"></span>
                                            <span class="sr-only">Dropdown</span>
                                        </button>
                                        <ul class="dropdown-menu" role="menu">
                                            <li><a href="#" @click.prevent="selectAll()">Sélectionner tout</a></li>
                                            <li><a href="#" @click.prevent="deselectAll()">Déselectionner tout</a></li>
                                            <li><a href="#" :disabled="resultatsSelected.length==0" @click.prevent="getExportFile()">
                                                Exporter la sélection en Excel</a>
                                            </li>
                                        </ul>
                                    </div>

                                    <b-dropdown class="margin-r-5" right id="ddown1" text="Colonnes">
                                        <div class="checkbox "
                                             style="margin-left: 5px;"
                                             v-for="(value, key) in optionsColumnsMember">
                                            <label :for="'col_mem'+value">
                                                <input :id="'col_mem'+value"
                                                       type="checkbox"
                                                       :value="key"
                                                       v-model="columnsMembersSelected">
                                                {{value}}
                                            </label>
                                        </div>
                                    </b-dropdown>

                                </div>
                            </div>
                            <div class="box-body">
                                <b-table
                                        id="tableListingResultsAdvancedSearch"
                                        v-if="!searching && resultatsRecherche.length>0"
                                        responsive bordered striped hover
                                        :items="resultatsRecherche"
                                        :fields="typeRecherche=='member' ? columnsIfMembers : columnsIfClub"

                                        :per-page="pagination_meta.per_page"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        :sort-compare="sortCompareAdvanced"
                                        :no-local-sorting="true"
                                        :no-sort-reset="true"
                                        :empty-text="'Aucun résultat'"
                                        :empty-filtered-text="'Aucun résultat'"
                                        foot-clone
                                        show-empty
                                >

                                    <template slot="actions" slot-scope="row">
                                        <router-link
                                                class="btn btn-default padding2"
                                                :to="{ name: 'Member', params: { member_id: row.item.id }}">
                                            <i class="glyphicon glyphicon-pencil"></i>
                                        </router-link>
                                    </template>

                                    <template slot="select" slot-scope="row">
                                        <input type="checkbox" :value="row.item.id" v-model="resultatsSelected">
                                    </template>

                                    <template slot="id" slot-scope="row">
                                        <span> {{ row.item.id | idFormat}}</span>
                                    </template>

                                    <template slot="nom" slot-scope="row">
                                        <router-link
                                                :to="{ name: 'Member', params: { member_id: row.item.id }}">
                                            {{ row.item.nom}}
                                        </router-link>
                                    </template>
                                    <template slot="prenom" slot-scope="row">
                                        <router-link
                                                :to="{ name: 'Member', params: { member_id: row.item.id }}">
                                            {{ row.item.prenom}}
                                        </router-link>
                                    </template>

                                    <template slot="mail" slot-scope="data">
                                        <a :href='"mailto:"+data.item.mail'>{{data.item.mail}}</a>
                                    </template>

                                    <template slot="licencie" slot-scope="data">
                                        {{data.value ? "OUI":"NON"}}
                                    </template>

                                    <template slot="dernierClub" slot-scope="data">
                                        <router-link v-if="data.value && data.value.id"
                                                     :to="{ name: 'Club', params: { club_id: data.value.id }}">
                                            {{ data.value.nom }}
                                        </router-link>
                                        <span v-else>-</span>
                                    </template>

                                </b-table>
                                <b-pagination size="md"
                                              @change="changePage"
                                              :total-rows="pagination_meta.total"
                                              v-model="pagination_meta.current_page"
                                              :per-page="pagination_meta.per_page">
                                </b-pagination>

                            </div>
                            <div class="box-footer">
                                <div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <b-btn v-b-toggle.collapse1 class="pull-right"
                                                   :disabled="mailsTextarea().trim()==''"
                                                   variant="default">Récupérer les mails
                                            </b-btn>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <b-collapse id="collapse1" class="margin">
                                                <b-card>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control"
                                                               @focus="$event.target.select()"
                                                               :value="mailsTextarea()">
                                                        <span class="input-group-btn">
                                                  <a type="button"
                                                     @click="copyToClipboard(mailsTextarea())"
                                                     class="btn btn-primary btn-flat">Copier les adresses dans le presse-papier</a>
                                                </span>
                                                    </div>
                                                </b-card>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    </div>
</template>

<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex'

    var _ = require('underscore')
    var moment = require('moment')
    var FileSaver = require('file-saver');

    export default {
        data() {
            return {
                affichage: [],
                date_naissance: null,
                searching: false,
                isBusy: false,
                sortBy: null,
                sortDesc: null,
                columnsMembersSelected: [
                    "id", "nom", "prenom", "date_naissance", "mail", "gsm", "licencie", "dernierClub"
                ],
                optionsColumnsMember: {
                    id: "Identifiant",
                    numlicenceABFT: "Numéro de licence ABFT",
                    fullName: "Nom complet",
                    nom: "Nom",
                    prenom: "Prenom",
                    adresse: "Adresse",
                    cp: "Code postal",
                    ville: "Ville",
                    date_naissance: "Date de naissance",
                    mail: "E-mail",
                    age: "Age",
                    gsm: "Gsm",
                    licencie: "Etat de la licence",
                    dernierClub: "Dernier club connu",
                    grade: "Grade",
                },

                ressourceDemandee: "membre",
                optionsMembre: {
                    isLicencie: 2
                },

                ModalFormationShown: false,
                filterFormation: "",
                formationsSelected: [],
                diplomeExact: false,
                include_administrative_members: false,

                ModalCompetitionShown: false,
                filterCompetition: "",
                competitionsSelected: [],

                ModalPosteShown: false,
                filterPoste: "",
                postesSelected: [],
                poste_only_for_club_licencie: 0,
                poste_only_for_clubs_selected: 0,

                ModalClubShown: false,
                filterClub: "",
                filterProvince: null,
                clubsSelected: [],

                ModalDiplomeShown: false,
                diplomesSelected: [],

                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 0
                },
                mailsForSelected: [],
                columnsIfMembers: null,
                columnsIfClub: [],
                resultatsRecherche: [],
                typeRecherche: "member",
                resultatsSelected: [],
                isLoaded: {
                    competition: false,
                    formation: false,
                    diplome: false,
                    poste: false,
                    club: false,
                    province: false,
                }
            }
        },
        methods: {
            ...mapActions({
                setListeFormation: 'setListeFormation',
                setListeCompetition: 'setListeCompetition',
                setDiplomes: 'setDiplomes',
                setListeClub: 'setListeClub',
                setPostes: 'setPostes',
                setProvinces: 'setProvinces',
            }),
            toogleSelectClubsLicencies: function () {
                // this.clubsSelected = [];
                this.listeClub(true).forEach((item) => {
                    if (!this.clubsSelected.find(club => {
                        return club.value == item.value;
                    }))
                        this.clubsSelected.push(item)
                });
            },
            selectAllClubsDisplayed: function () {
                this.listeClub().forEach((item) => {
                    if (!this.clubsSelected.find(club => club.value == item.value))
                        this.clubsSelected.push(item)
                });
            },
            clubsMailsTextarea: function () {
                let mails = [];
                this.clubsSelected.forEach((sel) => {
                    let club = this.getListeClub.find(c => c.id == sel.value)
                    if (club && club.mail && club.mail.trim() != "")
                        mails.push(club.mail.trim())
                });
                mails = [...new Set(mails)];
                return mails.join(";")
            },
            removeChip: function (list, item) {
                let i = list.indexOf(item)
                if (i !== -1)
                    list.splice(i, 1)
            },
            resetCriteres: function () {
                this.formationsSelected = []
                this.competitionsSelected = []
                this.diplomesSelected = []
                this.clubsSelected = []
                this.postesSelected = []
                this.poste_only_for_club_licencie = 0
                this.poste_only_for_clubs_selected = 0
                this.optionsMembre.isLicencie = 2
                this.include_administrative_members = false
            },
            selectAll: function () {
                this.resultatsSelected = [];
                this.resultatsSelected = this.resultatsRecherche.map(function (item) {
                    return item.id
                });
            },
            deselectAll: function () {
                this.resultatsSelected = [];
            },
            setColumnsMembers: function () {
                this.columnsIfMembers = [
                    {
                        label: '',
                        sortable: false,
                        key: 'select'
                    },
                    {
                        label: 'ID',
                        sortable: true,
                        key: 'id',
                        variant: _.contains(this.columnsMembersSelected, 'id') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Numéro ABFT',
                        sortable: true,
                        key: 'numlicenceABFT',
                        variant: _.contains(this.columnsMembersSelected, 'numlicenceABFT') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Nom complet',
                        sortable: true,
                        key: 'fullName',
                        variant: _.contains(this.columnsMembersSelected, 'fullName') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Nom',
                        sortable: true,
                        key: 'nom',
                        variant: _.contains(this.columnsMembersSelected, 'nom') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Prénom',
                        sortable: true,
                        key: 'prenom',
                        variant: _.contains(this.columnsMembersSelected, 'prenom') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Adresse',
                        sortable: true,
                        key: 'adresse',
                        variant: _.contains(this.columnsMembersSelected, 'adresse') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Code postal',
                        sortable: true,
                        key: 'cp',
                        variant: _.contains(this.columnsMembersSelected, 'cp') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Ville',
                        sortable: true,
                        key: 'ville',
                        variant: _.contains(this.columnsMembersSelected, 'ville') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Date de naissance',
                        sortable: true,
                        key: 'date_naissance',
                        variant: _.contains(this.columnsMembersSelected, 'date_naissance') ? '' : 'hidden-column'
                    },
                    {
                        label: 'E-mail',
                        sortable: true,
                        key: 'mail',
                        variant: _.contains(this.columnsMembersSelected, 'mail') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Age',
                        sortable: true,
                        key: 'age',
                        variant: _.contains(this.columnsMembersSelected, 'age') ? '' : 'hidden-column'
                    },
                    {
                        label: 'GSM',
                        sortable: true,
                        key: 'gsm',
                        variant: _.contains(this.columnsMembersSelected, 'gsm') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Licencie ?',
                        sortable: true,
                        key: 'licencie',
                        variant: _.contains(this.columnsMembersSelected, 'licencie') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Dernier club connu',
                        sortable: false,
                        key: 'dernierClub',
                        variant: _.contains(this.columnsMembersSelected, 'dernierClub') ? '' : 'hidden-column'
                    },
                    {
                        label: 'Grade',
                        sortable: true,
                        key: 'grade',
                        variant: _.contains(this.columnsMembersSelected, 'grade') ? '' : 'hidden-column'
                    },

                    {
                        label: 'Actions',
                        sortable: true,
                        key: 'actions'
                    },
                ];
            },
            loadAll() {
                this.loadListeCompetition()
                this.loadListeFormations()
                this.loadListeDiplome()
                this.loadListePostes()
                this.loadListeClub()
                this.loadListeProvinces()
            },
            allLoading: function () {
                return this.isLoaded.competition
                    && this.isLoaded.formation
                    && this.isLoaded.diplome
                    && this.isLoaded.poste
                    && this.isLoaded.club
                    && this.isLoaded.province
            },
            disabledButton: function () {
                if (this.choixPregenerer == "AttestationAffiliationClub")
                    return !(this.choixLicenceClub != null)
                return false
            },
            replaceAll: function (str, find, replace) {
                return str.replace(new RegExp(find, 'g'), replace);
            },
            loadListeFormations: function () {
                return this.$http.get(this.getRoute('getAllFormations')).then((response) => {
                    this.setListeFormation(response.body)
                    this.isLoaded.formation = true
                }, (response) => {
                    this.isLoaded.formation = false
                });
            },
            loadListeCompetition: function () {
                return this.$http.get(this.getRoute('getAllCompetitions')).then((response) => {
                    this.setListeCompetition(response.body)
                    this.isLoaded.competition = true
                }, (response) => {
                    this.isLoaded.competition = false
                });
            },
            loadListeDiplome: function () {
                return this.$http.get(this.getRoute('getAllDiplomes')).then((response) => {
                    this.setDiplomes(response.body)
                    this.isLoaded.diplome = true
                }, (response) => {
                    this.isLoaded.diplome = false
                });
            },
            loadListePostes: function () {
                this.$http.get(this.getRoute('getPostesForClub')).then((response) => {
                    this.setPostes(response.body)
                    this.isLoaded.poste = true
                }, (response) => {
                    this.isLoaded.poste = false
                });
            },
            loadListeClub: function () {
                return this.$http.get(this.getRoute('getAllClubs')).then((response) => {
                    this.setListeClub(response.body)
                    this.isLoaded.club = true
                }, (response) => {
                    this.isLoaded.club = false
                });
            },
            loadListeProvinces: function () {
                return this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
                    this.setProvinces(response.body)
                    this.isLoaded.province = true
                }, (response) => {
                    this.isLoaded.province = false
                });
            },
            listeFormation: function () {
                return _.map(_.filter(this.getListeFormation, (item) => {
                    return item.titre.toLowerCase().indexOf(this.filterFormation.toLowerCase()) != -1;
                }), (item2) => {
                    return {text: "" + item2.titre, value: item2.id};
                })
            },
            listePoste: function () {
                return _.map(_.filter(this.getPostes, (item) => {
                    return item.poste.toLowerCase().indexOf(this.filterPoste.toLowerCase()) != -1;
                }), (item2) => {
                    return {text: "" + item2.poste, value: item2.id};
                })
            },
            listeCompetition: function () {
                return _.map(_.filter(this.getListeCompetition, (item) => {
                    return item.titre.toLowerCase().indexOf(this.filterCompetition.toLowerCase()) != -1 ||
                        item.niveau.toLowerCase().indexOf(this.filterCompetition.toLowerCase()) != -1;
                }), (item2) => {
                    return {text: "" + item2.titre + " - " + item2.niveau, value: item2.id};
                })
            },
            listeClub: function (licenciedOnly = false) {
                return _.map(_.filter(this.getListeClub, (item) => {
                    if (licenciedOnly && !item.licence_active)
                        return false
                    let matchName = item.club.toLowerCase().indexOf(this.filterClub.toLowerCase()) != -1
                    let matchProvince = !this.filterProvince || item.id_province == this.filterProvince
                    return matchName && matchProvince
                }), (item2) => {
                    let text = item2.licence_active != null ? "<span class='text-green'>" + item2.numero_club + " " + item2.club + "</span>" : "<span class='text'>" + item2.numero_club + " " + item2.club + "</span>"
                    return {text: text, value: item2.id};

                })
            },
            listeDiplome: function (arrayDesc = []) {
                return _.map(
                    _.filter(this.getDiplomes, (item) => {
                        return arrayDesc.indexOf(item.desc) != -1
                    }),
                    (item2) => {
                        return {text: item2.grade, value: item2.id};
                    })
            },
            getTypesDiplomes: function () {
                let self = this
                // debugger;
                let result = _.groupBy(this.getFormation.diplomes, function (item) {
                    return item.desc;
                });
                // debugger;
                return result;
            },
            getLabelFromKey: function (key) {
                switch (key) {
                    case 'noire':
                        return 'Dan';
                        break;

                    default:
                        return key.charAt(0).toUpperCase() + key.slice(1);
                        break;
                }
            },
            flatten: function (obj) {
                var root = {};
                (function tree(obj, index) {
                    var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
                    for (var key in obj) {
                        if (!obj.hasOwnProperty(key)) continue;
                        root[index + key + suffix] = obj[key];
                        if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
                        if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
                    }
                })(obj, "");
                return root;
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },
            changePage: function (e) {
                this.pagination_meta.current_page = e
                this.getTableResults();
            },
            searchAdvanced: function () {
                this.sortDesc = null;
                this.sortBy = null;
                this.getTableResults();
            },

            constructForm: function () {
                return {
                    "perPage": this.pagination_meta.per_page,
                    "currentPage": this.pagination_meta.current_page,
                    "ressourceDemandee": this.ressourceDemandee,
                    "optionsMembre": {
                        "isLicencie": this.optionsMembre.isLicencie,
                        "selectionFormation": _.pluck(this.formationsSelected, 'value'),
                        "selectionCompetition": _.pluck(this.competitionsSelected, 'value'),
                        "selectionDiplomes": _.pluck(this.diplomesSelected, 'value'),
                        "diplomeExact": _.pluck(this.diplomeExact, 'value'),
                        "selectionClub": _.pluck(this.clubsSelected, 'value'),
                        "selectionPoste": _.pluck(this.postesSelected, 'value'),
                        "poste_only_for_club_licencie": this.poste_only_for_club_licencie,
                        "poste_only_for_clubs_selected": this.poste_only_for_clubs_selected,
                        "include_administrative_members": this.include_administrative_members,
                    }
                }
            },
            constructFormForExport: function (type = "xls") {
                return {
                    "typeDemande": type,
                    "ressourceDemandee": this.ressourceDemandee,
                    "columns": this.columnsMembersSelected,
                    "selection": this.resultatsSelected
                }
            },
            // getMailsOfSelected: function () {
            //     if (this.resultatsSelected.length <= 0)
            //         return;
            //
            //
            // },
            getExportFile: function () {
                if (this.resultatsSelected.length <= 0)
                    return;
                let these = this;
                this.$http.post(this.getRoute('exportAdvancedSearch'), JSON.stringify(this.constructFormForExport()), {responseType: 'blob'})
                    .then(function (response) {
                        var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
                        FileSaver.saveAs(blob, "exportAdvancedSearch.xls");
                        return response.blob();
                    }, (response) => {
                        these.$noty.error("Erreur dans la génération de l'export")
                    });
            },
            getTableResults: function () {
                this.searching = true;
                this.isBusy = true;
                let self = this
                this.$http.post(this.getRoute('advancedSearch'), this.constructForm())
                    .then((response) => {
                        // self.isBusy = false;
                        self.resultatsRecherche = response.body.data
                        self.pagination_meta = response.body.meta;
                        self.searching = false;
                        // self.$root.$emit('bv::refresh::table', 'tableListingResultsAdvancedSearch');
                    }, (response) => {
                        self.$noty.error("Erreur dans la recherche")
                        // self.isBusy = false;
                        self.searching = false;
                        self.resultatsRecherche = []
                        // self.$root.$emit('bv::refresh::table', 'tableListingResultsAdvancedSearch');
                    });
            },
            copyToClipboard: function (message) {
                let self = this;
                this.$copyText(message).then(function (e) {
                    self.$noty.success("E-mail copié dans le presse-papier")

                }, function (e) {
                    self.$noty.error("Erreur dans l'accès au presse-papier")
                })
            },

            mailsTextarea: function () {
                let str = "";
                this.mailsForSelected.forEach(item => {
                    if (item != null && item.trim() != "")
                        str += item + ";"
                })
                return str
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getListeFormation: 'getListeFormation',
                getListeCompetition: 'getListeCompetition',
                getListeClub: 'getListeClub',
                getPostes: 'getPostes',
                getDiplomes: 'getDiplomes',
                getProvinces: 'getProvinces',
            }),
            activeFiltersCount: function () {
                return this.formationsSelected.length
                    + this.competitionsSelected.length
                    + this.diplomesSelected.length
                    + this.clubsSelected.length
                    + this.postesSelected.length
            },

        },
        components: {},
        watch: {
            'columnsMembersSelected': function () {
                this.setColumnsMembers();
            },
            'pagination_meta.per_page': function () {
                this.getTableResults();
            },
            'resultatsSelected': function () {
                this.mailsForSelected = [];
                this.resultatsRecherche.forEach((item) => {
                    if (this.resultatsSelected.indexOf(item.id) != -1 && item.mail != null && item.mail != "")
                        this.mailsForSelected.push(item.mail)
                })
                this.mailsForSelected = [...new Set(this.mailsForSelected)];
            }
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            },

        },
        mounted() {
            var these = this
            this.$nextTick(function () {
                this.setColumnsMembers();
                this.loadAll()
            })
        }
    }
</script>

<style scoped>
    .rav-criteres {
        margin-top: 6px;
    }

    .rav-crit {
        border-top: 1px solid #f4f4f4;
        padding: 10px 2px;
    }

    .rav-crit:first-child {
        border-top: 0;
    }

    .rav-crit-head {
        display: flex;
        align-items: center;
    }

    .rav-crit-icon {
        width: 20px;
        text-align: center;
        color: #3c8dbc;
        margin-right: 8px;
    }

    .rav-crit-label {
        font-weight: 600;
    }

    .rav-crit-count {
        margin-left: 8px;
        min-width: 22px;
    }

    .rav-crit-head .rav-add-btn {
        margin-left: auto;
    }

    .rav-chips {
        margin-top: 8px;
        padding-left: 28px;
    }

    .rav-chip {
        display: inline-block;
        background: #eef3f7;
        border: 1px solid #d6e0e8;
        border-radius: 12px;
        padding: 2px 10px;
        margin: 0 6px 6px 0;
        font-size: 12px;
        line-height: 18px;
    }

    .rav-chip-x {
        margin-left: 6px;
        color: #a0392e;
        font-weight: bold;
        text-decoration: none;
    }

    .rav-chip-x:hover {
        color: #c0392b;
    }

    .rav-crit-options {
        margin-top: 6px;
        padding-left: 28px;
    }

    .rav-active-filters {
        display: inline-block;
        line-height: 34px;
        color: #777;
    }

    .rav-info {
        margin-left: 4px;
        cursor: help;
    }

    /* Évite que le menu déroulant « Colonnes » soit rogné par l'overflow de la box */
    .rav-results-box {
        overflow: visible;
    }
</style>



// WEBPACK FOOTER //
// src/components/Outils/RechercheAvancee.vue